<template>
  <div class="dropdown c-dropdown">
    <div class="dropdown-trigger">
      <button aria-controls="dropdown-menu2" aria-haspopup="true" class="button">
        <span>{{ ddLabel }}</span>
        <img class="dropdown__arrow--closed" src="/static/img/arrows/arrow_down_blue_dark.svg"/>
        <img class="dropdown__arrow--opened" src="/static/img/arrows/arrow_up_white.svg"/>
      </button>
    </div>
    <div id="dropdown-menu2" class="dropdown-menu" role="menu">
      <div class="dropdown-content">
        <template v-for="(option, idx) in ddOptions">
          <div class="dropdown-item" :class="{'selected': selectedRadioVal.value === option.value}" @click="clickHandler(option)">
            {{ option.label }}
          </div>
        </template>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'BulmaDropdown2',
  props: {
    ddLabel: {
      type: String,
      required: true
    },
    ddOptions: {
      type: Array,
      required: true
    }
  },
  data () {
    return {
      selectedRadioVal: {}
    }
  },
  created () {
    const selectedOpt = this.ddOptions.find(option => 'selected' in option && option.selected)
    if (typeof selectedOpt !== 'undefined') {
      this.selectedRadioVal = selectedOpt
    }
  },
  methods: {
    clickHandler (value) {
      this.selectedRadioVal = value
    }
  },
  watch: {
    selectedRadioVal: function (newVal) {
      this.$emit('bulmaDd2Change', {
        key: this.ddLabel,
        value: newVal.value,
        label: newVal.label,
        data: newVal.data || {}
      })
    }
  }
}
</script>

<style lang="scss" scoped>
@import "@/assets/scss/_variables.scss";
@import "@/assets/scss/vendor/_breakpoints.scss";

.dropdown {
  &.is-active {
    .dropdown-trigger button {
      background-color: map-get($colors, 'blue-dark');
      color: #fff;
      box-shadow: none;
      border-bottom-left-radius: 0;
      border-bottom-right-radius: 0;

      .dropdown__arrow--opened {
        display: block;
      }

      .dropdown__arrow--closed {
        display: none;
      }
    }
  }

  .dropdown-trigger button {
    justify-content: space-between;
    border: 0.5px solid map-get($colors, 'blue-dark');
    padding: 5px 9px 4px 9px;
    color: map-get($colors, 'blue-dark');
    height: auto;
    font-size: 16px;
    font-weight: 600;

    img {
      width: 15px;
      margin-left: 14px;
    }

    .dropdown__arrow--opened {
      display: none;
    }

    .dropdown__arrow--closed {
      display: block;
    }
  }

  .dropdown-menu {
    padding-top: 0;
    min-width: 100%;

    .dropdown-content {
      border: 0.5px solid rgba(88, 89, 91, 0.32);
      box-shadow: 0 0 30px 0 rgba(0, 0, 0, 0.16);
      border-top-left-radius: 0;
      border-top-right-radius: 0;
      border-bottom-left-radius: 4px;
      border-bottom-right-radius: 4px;
      padding: 2px 0 0;
      text-align: left;

      .dropdown-item {
        color: map-get($colors, 'gray');
        padding: 2px 16px 2px 19px;
        margin: 9px 0;
        cursor: pointer;

        &.selected, &:hover, &:focus {
          background-color: #d6dff4;
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/dropdowns/BulmaDropdown2.vue